module.exports = __webpack_public_path__ + "static/media/exterior4.b18d56cb.webp";